import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import {SessionSetting} from '../middleware/MyConstant';
import s from './SchoolConfig.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {modifiedDate} from '../middleware/dateControl';
import {MyInput} from './Utilities/MyInput';

import MyComponentLoading from '../components/Utilities/MyComponentLoading';

export default function SchoolConfig(prop) {	
	const navigate = useNavigate();
	let schoolId = prop.schoolId;
	const [sessionsData, setSessionsData] = useState([]);
	const [magicPenQ, setMagicPenQ] = useState(50);
	
	const [eduLv, setEduLv] = useState('');
	const [name, setName] = useState("");
	const [nameEn, setNameEn] = useState("");
	const [nameHk, setNameHk] = useState("");
	
	const fetchData = async () => {
		
		let res = await getData('schoolApi/getSessionByOrganizationId?orgId=' + schoolId, navigate);
		setSessionsData(res.data);
	}
	
	const fetchBasic = async () => {
		
		let res = await getData('schoolApi/schoolBasic?orgId=' + schoolId, navigate);
		
		let data = res.data;
		setName(data.name);
		setNameEn(data.nameEn);
		setNameHk(data.nameHk);
		setEduLv(data.eduLv);
	}
	
	useEffect(() => {
		fetchBasic();
		fetchData();
	}, []);
	
	const resetMagicPen = async () => {		
		let obj = { orgId:schoolId, count:magicPenQ }
		
		await postData("schoolApi/resetMagicPen", obj, navigate); 

	}
	const createNew = async () => {		
		let obj = { orgId:schoolId }
		
		await postData("schoolApi/createNew", obj, navigate); 
		fetchData();
	}
	
	const deleteSession = async (sessionId) => {		
		let obj = { sessionId }
		
		await postData("schoolApi/deleteSession", obj, navigate); 
		fetchData();
	}
	
	const updateSessionBasic = async (configIdx) => {		
		let obj = { sessionId:sessionsData[configIdx].id, sessionsData:sessionsData[configIdx] }
		
		postData("schoolApi/updateSessionBasic", obj, navigate); 

	}
	
	const ConfigButton = ({configIdx, configKey, dbKey, configName}) => {
		
		const configSession = () => {
			sessionsData[configIdx][configKey] = !sessionsData[configIdx][configKey];
			
			let obj = { sessionId:sessionsData[configIdx].id, dbKey }
			setSessionsData([...sessionsData]);
			postData("schoolApi/updateSessionRight", obj, navigate); 
		}
		
		return (
			<div>
				{
					(sessionsData[configIdx][configKey]) && (<BlueButton isEnabled={true} clickedAction={()=>configSession()} bText={configName} />)
				}
				{
					(!sessionsData[configIdx][configKey]) && (<RedButton isEnabled={true} clickedAction={()=>configSession()} bText={configName} />)
				}
			</div>)
	}
	
	
		
	const style={
		row:{display:"flex", flexDirection:"row", gap:"10px", alignItems:"center"}
	}
	
	const updateEduLv = async (el) => {
		setEduLv(el);
		let obj = { orgId:schoolId, eduLv:el }
		postData("schoolApi/updateEduLv", obj, navigate); 
	}
	const updateName = async () => {
		let obj = { orgId:schoolId, name }
		postData("schoolApi/updateName", obj, navigate); 
	}
	const updateNameHk = async () => {
		let obj = { orgId:schoolId, nameHk }
		postData("schoolApi/updateNameHk", obj, navigate); 
	}
	const updateNameEn = async () => {
		let obj = { orgId:schoolId, nameEn }
		postData("schoolApi/updateNameEn", obj, navigate); 
	}
	
	return (<div>
		<div style={{borderBottom:"1px solid black", padding:"10px 0", textAlign:"left", display:"flex"}}>
			<div>
				<div style={style.row}>
					<div style={{fontWeight:"bold"}}>Display Name:</div>
					<MyInput inputLabel={""} dataInput={name} changeAction={setName} />		
					<div>
						<GreenButton overrideStyle={{padding:"2px", fontSize:"14px"}} isEnabled={true} clickedAction={()=>{updateName()}} bText={"Update"} />
					</div>
				</div>
				
				<div style={style.row}>
					<div style={{fontWeight:"bold"}}>Name EN:</div>
					<MyInput inputLabel={""} dataInput={nameEn} changeAction={setNameEn} />		
					<div>
						<GreenButton overrideStyle={{padding:"2px", fontSize:"14px"}} isEnabled={true} clickedAction={()=>{updateNameEn()}} bText={"Update"} />
					</div>
				</div>
				
				<div style={style.row}>
					<div style={{fontWeight:"bold"}}>Name HK:</div>
					<MyInput inputLabel={""} dataInput={nameHk} changeAction={setNameHk} />		
					<div>
						<GreenButton overrideStyle={{padding:"2px", fontSize:"14px"}} isEnabled={true} clickedAction={()=>{updateNameHk()}} bText={"Update"} />
					</div>
				</div>
			
				<div style={{margin:"10px", display:"flex", alignItems:"center", gap:"10px"}}>
					{
						["P","S"].map((el, indexEL) => (
							<div key={"edulv" + indexEL}
								className={(eduLv==el) ? s.toggleButtonChosen : s.toggleButtonOption}
								onClick={()=>updateEduLv(el)}>{(el == "P") ? "Primary" : "Secondary"}</div>
						))
					}
				</div>
				<div>
					<GreenButton isEnabled={true} clickedAction={createNew} bText={"Create New Session"} />	
				</div>
			</div>
			
		
				{/*
			<div style={{display:"flex", margin:"0 0 0 auto", gap:"5px", alignItems:"center"}}>
				Magic Pen
				<input value={magicPenQ} style={{width:'50px'}} onChange={(e)=>{
						setMagicPenQ(e.target.value);
					}} />
				<GreenButton isEnabled={true} clickedAction={resetMagicPen} bText={"Reset all user"} />	
</div>*/}
		</div>
		{
			sessionsData.map((s, indexS) => (<div style={{ margin:"10px 0"}}>
			<div style={{textAlign:"left"}}>
				{s.id}
			</div>
			<div style={{display:"flex", flexDirection:"column",gap:"5px", border:"1px solid black", padding:"5px", borderRadius:"5px"}}>
				
				<div style={{display:"flex", gap:"5px"}}>
					<div style={{border:"1px solid black", borderRadius:"5px", padding:"5px", background:"#917160", color:"white"}}>
						<div style={{fontWeight:"bold", textAlign:"left"}}>Start Date</div>
						<div className={s.tableRow} style={{flex: '0 0 200px', background:"white"}}>
							<input value={sessionsData[indexS].startDate} 
								placeholder="yyyy-mm-dd"
								style={{width:'200px'}} onChange={(e)=>{
						
								sessionsData[indexS].startDate = e.target.value;
								setSessionsData([...sessionsData]);
								
							}} />
						</div>
						
					</div>
					
					<div style={{border:"1px solid black", borderRadius:"5px", padding:"5px", background:"#917160", color:"white"}}>
						<div style={{fontWeight:"bold", textAlign:"left"}}>End Date</div>
						<div className={s.tableRow} style={{flex: '0 0 200px'}}>
							<input value={sessionsData[indexS].endDate} 
								placeholder="yyyy-mm-dd"
								style={{width:'200px'}} onChange={(e)=>{
						
								sessionsData[indexS].endDate = e.target.value;
								setSessionsData([...sessionsData]);
								
							}} />
						</div>
					</div>
						
					<div style={{border:"1px solid black", borderRadius:"5px", padding:"5px", background:"#439441", color:"white"}}>
						<div style={{fontWeight:"bold", textAlign:"left"}}>Duration Limit</div>
						<div className={s.tableRow} style={{flex: '0 0 200px'}}>
							<input value={sessionsData[indexS].durationLimit} 
								style={{width:'200px'}} onChange={(e)=>{
						
								sessionsData[indexS].durationLimit = e.target.value;
								setSessionsData([...sessionsData]);
								
							}} />
						</div>
					</div>
					
					<div style={{border:"1px solid black", borderRadius:"5px", padding:"5px", background:"#439441", color:"white"}}>
						<div style={{fontWeight:"bold", textAlign:"left"}}>Writing Limit</div>
					
						<div className={s.tableRow} style={{flex: '0 0 200px'}}>
							<input value={sessionsData[indexS].writingLimit} 
								style={{width:'200px'}} onChange={(e)=>{
						
								sessionsData[indexS].writingLimit = e.target.value;
								setSessionsData([...sessionsData]);
								
							}} />
						</div>
					</div>
					
					<div style={{border:"1px solid black", borderRadius:"5px", padding:"5px", background:"#439441", color:"white"}}>
						<div style={{fontWeight:"bold", textAlign:"left"}}>Read out loud Ceiling</div>
					
						<div className={s.tableRow} style={{flex: '0 0 200px'}}>
							<input value={sessionsData[indexS].readOutLoudCeiling} 
								style={{width:'200px'}} onChange={(e)=>{
						
								sessionsData[indexS].readOutLoudCeiling = e.target.value;
								setSessionsData([...sessionsData]);
								
							}} />
						</div>
					</div>
					
					<div style={{margin:"5px", padding:"5px"}}>
						<GreenButton isEnabled={true} clickedAction={()=>updateSessionBasic(indexS)} bText={"Update All"} />
					</div>
					
					<div style={{margin:"5px 5px 5px auto", padding:"5px"}}>
						<RedButton isEnabled={true} clickedAction={()=>deleteSession(s.id)} bText={"Delete"} />
					</div>
				</div>
				<div style={{display:"flex", gap:"5px"}}>
					{
						SessionSetting.map((S, IS) => (
							<ConfigButton configIdx={indexS} configKey={S.configKey} dbKey={S.dbKey} configName={S.configName} />
						))
						
					}
					{/*
					<ConfigButton configIdx={indexS} configKey="writing" dbKey="writing" configName="Writing" />
					<ConfigButton configIdx={indexS} configKey="azureReadOutLoud" dbKey="azure_read_out_loud" configName="Azure Read Out Loud" />
					<ConfigButton configIdx={indexS} configKey="reading" dbKey="reading" configName="Reading" />
					<ConfigButton configIdx={indexS} configKey="longReading" dbKey="long_reading" configName="Long Reading" />
					<ConfigButton configIdx={indexS} configKey="speaking" dbKey="speaking" configName="Speaking" />
					<ConfigButton configIdx={indexS} configKey="listening" dbKey="listening" configName="Listening" />
					<ConfigButton configIdx={indexS} configKey="idea" dbKey="idea" configName="Idea" />
					<ConfigButton configIdx={indexS} configKey="grammar" dbKey="grammar" configName="Grammar" />
					<ConfigButton configIdx={indexS} configKey="wordBank" dbKey="word_bank" configName="Word Bank" />
		<ConfigButton configIdx={indexS} configKey="teachingNote" dbKey="teaching_note" configName="Teaching Note" />*/}
				</div>
			
			</div></div>))
		}
	
	</div>)
	
}

